import { IPaginatedResponse, IResponse } from "../../../model";
import ServiceBase from "../../../servicebase";
import { IProcesoCron, IProcesoCronRun } from "../model/IProcesoCron";

export default class ProcesoCronService extends ServiceBase {
  //get = (data:{ id?: number }) : Promise<IResponse<IProcesoCron>> => 
  //  this.GetFetch<IResponse<IProcesoCron>>('entity/procesocron', data);

  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string, nombre?: string, codigo?: string, activo?: boolean }) : Promise<IPaginatedResponse<IProcesoCron>> => 
    this.GetFetch<IPaginatedResponse<IProcesoCron>>('entity/procesocron/find', data);
    
  //upsert = (data:IProcesoCron) : Promise<IResponse<IProcesoCron>> => 
  //  this.PostFetch<IResponse<IProcesoCron>>('entity/procesocron', data);

  delete = (data:{ id:number, undelete?: boolean}) : Promise<IResponse<void>> => 
    this.DeleteFetch<IResponse<void>>('entity/procesocron', data);  

  run = (data:{ id?: number }) : Promise<IResponse<unknown>> => 
    !window.app_usems
      ? this.PostFetch<IResponse<unknown>>('entity/procesocron/run', data)
      : this.PostFetch<IResponse<unknown>>(`entity/procesocron/run?id=${data.id}`, {});

  runs = {
    find: (data:{ pageIndex?: number, pageSize?: number, sort?: string, idprocesocron?: number }) : Promise<IPaginatedResponse<IProcesoCronRun>> => 
      this.GetFetch<IPaginatedResponse<IProcesoCronRun>>('entity/procesocron/runs/find', data),
  }
}
